import { TafiffSummary } from '../api/tariffSummaryApi';
import { CellLayout } from 'src/common/components/ConfigurableTable/Components/Cells/CellLayout';
import { GetElementType } from 'src/common/tsHelpers';
import { TariffSummaryUsageCellDisplay } from './TariffSummaryUsageCellDisplay';
import React from 'react';
import { toLocaleBrowserSettings } from 'src/i18n/numberLocale';

type TariffSummarySMSUsageCellProps = {
  row: GetElementType<TafiffSummary['items']>;
};

export const TariffSummarySMSUsageCell = React.memo(
  ({
    row: { sent, allowanceSMS, forecastSMS, consumptionLevelSent, consumptionLevelForecastSMS },
  }: TariffSummarySMSUsageCellProps) => {
    return (
      <CellLayout>
        <TariffSummaryUsageCellDisplay
          {...(sent == null
            ? { usage: null, forecast: null, allowence: null, consumptionLevelUsage: null, consumptionLevelForecast: null }
            : { usage: sent, forecast: forecastSMS!, allowence: allowanceSMS!, consumptionLevelUsage: consumptionLevelSent!, consumptionLevelForecast: consumptionLevelForecastSMS! }
          )}
          valueFormater={toLocaleBrowserSettings}
        />
      </CellLayout>
    );
  },
);
